import { reloadDocuments } from "actions/documents-actions";
import { storage, DOCUMENTS_SORTING_ORDER } from "utils/local-storage";
import { filterActionGenerator } from "actions/shared/shared-action-generators";
import { store } from "store";

export const ADD_VENDOR_TO_FILTER = "actions/document-filters/add-vendor-to-filter";
export const REMOVE_VENDOR_FROM_FILTER = "actions/document-filters/remove-vendor-from-filter";
export const ADD_CATEGORY_TO_FILTER = "actions/document-filters/add-category-to-filter";
export const REMOVE_CATEGORY_FROM_FILTER = "actions/document-filters/remove-category-from-filter";
export const ADD_PAYMENT_TYPE_TO_FILTER = "actions/document-filters/add-payment-type-to-filter";
export const REMOVE_PAYMENT_TYPE_FROM_FILTER = "actions/document-filters/remove-payment-type-to-filter";
export const ADD_CURRENCY_TO_FILTER = "actions/document-filters/add-currency-to-filter";
export const REMOVE_CURRENCY_FROM_FILTER = "actions/document-filters/remove-currency-from-filter";
export const SET_EXPORT_TYPE_FILTER = "actions/document-filters/set-export-type-filter";
export const CLEAR_EXPORT_TYPE_FILTER = "actions/document-filters/clear-export-type-filter";
export const ADD_ENVELOPE_TO_FILTER = "actions/document-filters/add-envelope-to-filter";
export const ADD_START_DATE_TO_FILTER = "actions/document-filters/add-start-date-to-filter";
export const ADD_END_DATE_TO_FILTER = "actions/document-filters/add-end-date-to-filter";
export const REMOVE_ENVELOPE_FROM_FILTER = "actions/document-filters/remove-envelope-from-filter";
export const ORDER_BY = "actions/document-filters/order-by";
export const ADD_CARD_NUMBER_TO_FILTER = "actions/document-filters/add-card-number-to-filter";
export const REMOVE_CARD_NUMBER_FROM_FILTER = "actions/document-filters/remove-card-number-from-filter";
export const ADD_SEARCH_QUERY_TO_FILTER = "actions/document-filters/add-search-query-to-filter";
export const REMOVE_SEARCH_QUERY_FROM_FILTER = "actions/document-filters/remove-search-query-from-filter";
export const UPDATE_SEARCH_QUERY = "actions/document-filters/update-search-query";
export const SET_TRASH_VIEW = "actions/document-filters/set-trash-view";
export const RESET_FILTERS = "acitons/document-filters/reset-filters";
export const ADD_DOCUMENT_TYPE_TO_FILTER = "actions/document-filters/add-document-type-to-filter";
export const REMOVE_DOCUMENT_TYPE_FROM_FILTER = "actions/document-filters/remove-document-type-from-filter";
export const ADD_VIEWED_STATUS_TO_FILTER = "actions/document-filters/add-viewed-status-to-filter";
export const REMOVE_VIEWED_STATUS_FROM_FILTER = "actions/document-filters/remove-viewed-status-from-filter";
export const SET_FILTERS = "actions/document-filters/set-filters";
export const ADD_NAME_TO_FILTER = "actions/document-filters/add-name-to-filter";
export const REMOVE_NAME_FROM_FILTER = "actions/documents-filters/remove-name-from-filter";
export const UPDATE_NAME = "actions/documents-filters/update-name";
export const ADD_TOTAL_MAX_TO_FILTER = "actions/document-filters/add-total-max-to-filter";
export const ADD_TOTAL_MIN_TO_FILTER = "actions/document-filters/add-total-min-to-filter";
export const UPDATE_TOTAL_FILTER = "actions/documents-filter/update-total-filter";

export const addStartDateToFilterAction = (date) =>
  filterActionGenerator(ADD_START_DATE_TO_FILTER, reloadDocuments, date);

export const addEndDateToFilterAction = (date) =>
  filterActionGenerator(ADD_END_DATE_TO_FILTER, reloadDocuments, date);

export const setExportTypeFilterAction = (key) =>
  filterActionGenerator(SET_EXPORT_TYPE_FILTER, reloadDocuments, key);

export const clearExportTypeFilterAction = () =>
  filterActionGenerator(CLEAR_EXPORT_TYPE_FILTER, reloadDocuments);

export const addVendorToFilterAction = (name) =>
  filterActionGenerator(ADD_VENDOR_TO_FILTER, reloadDocuments, name);

export const addCategoryToFilterAction = (name) =>
  filterActionGenerator(ADD_CATEGORY_TO_FILTER, reloadDocuments, name);

export const addPaymentTypeToFilterAction = (key) =>
  filterActionGenerator(ADD_PAYMENT_TYPE_TO_FILTER, reloadDocuments, key);

export const addCurrencyToFilterAction = (key) =>
  filterActionGenerator(ADD_CURRENCY_TO_FILTER, reloadDocuments, key);

export const removeVendorFromFilterAction = (name) =>
  filterActionGenerator(REMOVE_VENDOR_FROM_FILTER, reloadDocuments, name);

export const removeCategoryFromFilterAction = (name) =>
  filterActionGenerator(REMOVE_CATEGORY_FROM_FILTER, reloadDocuments, name);

export const addEnvelopeToFilterAction = (code) =>
  filterActionGenerator(ADD_ENVELOPE_TO_FILTER, reloadDocuments, code);

export const removePaymentTypeFromFilterAction = (key) =>
  filterActionGenerator(REMOVE_PAYMENT_TYPE_FROM_FILTER, reloadDocuments, key);

export const removeEnvelopeFromFilterAction = (code) =>
  filterActionGenerator(REMOVE_ENVELOPE_FROM_FILTER, reloadDocuments, code);

export const removeCurrencyFromFilterAction = (key) =>
  filterActionGenerator(REMOVE_CURRENCY_FROM_FILTER, reloadDocuments, key);

export const addCardNumberToFilterAction = (key) =>
  filterActionGenerator(ADD_CARD_NUMBER_TO_FILTER, reloadDocuments, key);

export const removeCardNumberFromFilterAction = (key) =>
  filterActionGenerator(REMOVE_CARD_NUMBER_FROM_FILTER, reloadDocuments, key);

export const addSearchQueryToFilterAction = (query) =>
  filterActionGenerator(ADD_SEARCH_QUERY_TO_FILTER, reloadDocuments, query);

export const removeSearchQueryFromFilterAction = () =>
  filterActionGenerator(REMOVE_SEARCH_QUERY_FROM_FILTER, reloadDocuments);

export const addDocumentTypeToFilterAction = (type) =>
  filterActionGenerator(ADD_DOCUMENT_TYPE_TO_FILTER, reloadDocuments, type);

export const removeDocumentTypeFromFilterAction = () =>
  filterActionGenerator(REMOVE_DOCUMENT_TYPE_FROM_FILTER, reloadDocuments);

export const addViewedStatusToFilterAction = (key) =>
  filterActionGenerator(ADD_VIEWED_STATUS_TO_FILTER, reloadDocuments, key);

export const removeViewedStatusFromFilterAction = () =>
  filterActionGenerator(REMOVE_VIEWED_STATUS_FROM_FILTER, reloadDocuments);

export const updateSearchQueryAction = (query) => ({
  type: UPDATE_SEARCH_QUERY,
  data: { query }
});

export const setTrashViewAction = (isTrash) =>
  filterActionGenerator(SET_TRASH_VIEW, reloadDocuments, isTrash);

export const orderByAction = (key) => (dispatch) => {
  dispatch({
    type: ORDER_BY,
    data: { key }
  });
  storage.set(DOCUMENTS_SORTING_ORDER, JSON.stringify({
    orderBy: key,
    orderDirection: store.getState().documentFilters.orderDirection
  }));
  reloadDocuments(dispatch);
};

export const resetFiltersAction = () => ({
  type: RESET_FILTERS
});

export const setFiltersAction = (filters) => ({
  type: SET_FILTERS,
  data: { filters }
});

export const addNameToFilterAction = (name) =>
  filterActionGenerator(ADD_NAME_TO_FILTER, reloadDocuments, name);

export const removeNameFromFilterAction = () =>
  filterActionGenerator(REMOVE_NAME_FROM_FILTER, reloadDocuments);

export const updateNameAction = (name) => ({
  type: UPDATE_NAME,
  data: { name }
});

export const addTotalFilterAction = (type, value) => {
  if (type === "min") {
    return filterActionGenerator(ADD_TOTAL_MIN_TO_FILTER, reloadDocuments, value);
  }
  return filterActionGenerator(ADD_TOTAL_MAX_TO_FILTER, reloadDocuments, value);
};

export const updateTotalFilterAction = (type, value) => ({
  type: UPDATE_TOTAL_FILTER,
  data: { type, value }
});




// WEBPACK FOOTER //
// ./src/js/actions/document-filters-actions.js